export { default } from './page-thanks';
